var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modals",attrs:{"tabindex":"-1"}},_vm._l((Object.keys(_vm.modals)),function(id){return _c('ComponentLoader',_vm._b({key:'modal_' + id,ref:'modal_' + id,refInFor:true,on:{"close":function($event){return _vm.update({ open: false, id, data: $event })}}},'ComponentLoader',_vm.modals[id],false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }